import React from "react";
import "./MainTablePaginationAdv.css";

function MainTablePaginationAdvWeekly({
  pageSize,
  setPageSize,
  previousPage,
  canPreviousPage,
  pageIndex,
  pageOptions,
  nextPage,
  canNextPage,
  gotoPage,
  pageCount,
}) {
  return (
    <>
      <div className="table_footer-modal-pagination_weekly">
        <div className="Adv_Pagination_Button_div">
          <button
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            className="Adv_Pagination_Button"
          >
            {"<<"}
          </button>
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="Adv_Pagination_Button"
          >
            {"<"}
          </button>
          <span style={{ marginTop: "5px" }}>
            <strong>
              Page {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="Adv_Pagination_Button"
          >
            {">"}
          </button>
          <button
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
            className="Adv_Pagination_Button"
          >
            {">>"}
          </button>
        </div>
        <div className="goto_pagination_div">
          <span>
            <strong> Go to Page : </strong>
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "50px", textAlign:"center" }}
            />
          </span>
          <div style={{ marginTop: "0px" }}>
            <strong> Page Size : </strong>
            <input
              value={pageSize}
              onChange={(e) => {
                if(Number(e.target.value) >= 1){
                  setPageSize(Number(e.target.value));
                }
              }}
              type="number"
              min="1"
              style={{ width: "60px", textAlign:"center" }}
            />
          </div>
        </div>
        {/* </div> */}
      </div>
    </>
  );
}
export default MainTablePaginationAdvWeekly;
